import { handleError } from '../errorHandling';
import authRequest from '../authRequest';
import DrugInteractionsPresenter from '../../presenters/DrugInteractionsPresenter';

const createCheck = async (medications, patientUuid) => {
  try {
    const response = await authRequest('/drug_interactions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        medications: medications,
        patient_uuid: patientUuid
      }
    });
    
    return new DrugInteractionsPresenter(response.data);

  } catch (error) {
    handleError(error, 'Failed to check drug interactions');
    throw error;
  }
};

export default createCheck; 